import { cookies } from '@/shared/lib/cookies'
import type { Language } from '@/shared/lib/i18n'

export function setPreferredLanguage(lang: Language) {
    cookies.set('user_select_lang', lang, {
        path: '/',
        samesite: 'none',
        secure: true,
        expires: 365,
    })
}

export function getPreferredLanguage(): string | undefined {
    return cookies.get('user_select_lang')
}
